import { useState } from 'react';
import useAuthForm from '../../../hooks/useAuthForm';
import { forgotPassword } from '../../../services/authService';
import validateByType from '../../../hooks/useFormValidation';

const useForgotPassword = () => {
  const initialValues = { email: '' };

  return useAuthForm({
    initialValues,
    validateFn: (form) => validateByType('forgotPassword', form),
    submitFn: forgotPassword,
    onSuccessNavigateTo: '/confirm',
  });
};

export default useForgotPassword;
